<template>
  <div>
    <Modal v-model="visible" width="600px" title="新增" :footer-hide="true" :mask-closable="false" class="my-modal top">
      <Form ref="form" :model="formData" :label-width="70" class="page-form">
        <FormItem prop="policyNo" label="保单号" class="full" :rules=" $units.formRule.required('请输入') ">
          <Input v-model.trim="formData.policyNo" placeholder="请先输入保单号校验" @on-change="loadPolicy = false; getPolicy()" />
          <div v-if="type == -1">未查询到该保单，请核实保单号，或自建理赔记录。</div>
          <div v-else-if="type == 1">该供应商未提供在线理赔售后服务，请联系供应商，或自建理赔记录。</div>
          <div style="line-height: 1.2;margin-top: 7px;" v-else-if="type == 2">该供应商提供了在线理赔售后服务，您可以选择申请在线理赔<span
              v-if="companyMobile">，或致电{{ companyMobile }}</span>。</div>
        </FormItem>
        <br>
        <FormItem label="供应商" class="full" v-if="type == 1 || type == 2">
          <Input :value="formData.supplierName||'-'" placeholder="" disabled />
        </FormItem>
        <FormItem label="产品名称" class="full" v-if="type == 1 || type == 2">
          <Input :value="formData.productName||'-'" placeholder="" disabled />
        </FormItem>

      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="next(2)" v-if="type == 2">申请在线理赔</Button>
        <Button type="primary" @click="next(1)" v-if="type == -1 || type == 1 || type == 2">自建理赔记录</Button>
      </div>
    </Modal>
    <!-- 下一步填写表单 -->
    <form-modal-step2 ref="formModalStep2" @back="visible = true" @reload="$emit('reload')"></form-modal-step2>
  </div>
</template>

<script>
import formModalStep2 from './formModalStep2';
import _ from "lodash";
export default {
  components: {
    formModalStep2
  },
  props: [],
  data() {
    return {
      visible: false,
      loading: false,
      formData: {},
      tableItem: {},
      companyMobile: "",//供应商电话
      type: '',//-1非系统保单 1录入保单 2平台保单 
    };
  },
  created() {
  },
  methods: {
    open(tableItem = {}) {
      this.formData = {}
      this.tableItem = tableItem;
      this.visible = true;
      this.type = '';
      this.$nextTick(() => {
        // 清除验证信息
        this.$refs.form && this.$refs.form.fields.forEach(item => {
          item.validateState = '';
          item.validateMessage = '';
        });
      })
    },
    // 获取保单数据
    getPolicy: _.debounce(function () {
      if (!this.formData.policyNo) {
        this.type = '';
        this.loadPolicy = true;
        return;
      }
      this.loadPolicy = false;
      this.$http({
        url: '/buz/policy/simple/queryByPolicyNo',
        type: 'GET',
        forced: true,
        data: {
          policyNo: this.formData.policyNo
        },
      }).then((res) => {
        this.loadPolicy = true;
        if (res.httpCode == 1) {//保单存在
          this.type = res.data.supportOnlineCompensation == 1 ? 2 : 1;
        } else {//保单不存在
          this.type = -1;
        }
        this.companyMobile = res.data.mobile;
        this.$set(this.formData, 'supplierName', res.data.supplierName);
        this.$set(this.formData, 'productName', res.data.productName);
        this.$set(this.formData, 'contactName', res.data.holderName);
        this.$set(this.formData, 'contactMobile', res.data.holderMobile);
        this.$set(this.formData, 'accidentPerson', res.data.insuranceName);
        this.$set(this.formData, 'orgId', res.data.orgId);
        this.$set(this.formData, 'orgName', res.data.orgName);
        this.$set(this.formData, 'groupId', res.data.groupId);
        this.$set(this.formData, 'salesmanId', res.data.salesmanId);
      })
    }, 500),
    // 下一步 type 1自建理赔记录 2申请在线理赔  
    next(type) {
      if (!this.loadPolicy) {
        this.$notice.msg(this.formData.policyNo ? '保单校验中，请稍后重试' : '请输入保单号');
        return;
      }
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        const data = {
          formType: this.type,
          sourceType: type,
        }
        Object.assign(data, this.formData, this.tableItem);
        console.log(data);
        this.$refs.formModalStep2.open(data);
        this.visible = false;
      });

    },
  },


};
</script>
